import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { addStore } from 'common/util';
import FieldFactory from 'common/components/field-factory';
import ConfirmButton from 'common/components/confirm-button';

@inject('artistStore', 'userStore', 'formStore', 'genreStore', 'apiStore')
@observer
class EditArtistForm extends React.Component {
	render () {
		const { artistStore, userStore, formStore, genreStore } = this.props;
		const FieldWithStore = addStore(FieldFactory, { formStore });

		return (
			<div>
				<div className="grid-x" data-ta="artistInfoForm">
					<div className="small-12 large-12 cell">
						<h2>Edit Information</h2>
					</div>

					<div className="small-12 large-4 cell">
						{/* <FieldWithStore fieldKey="artist.name" store={ artistStore } /> */}
						<FieldWithStore fieldKey="user.userName" store={ userStore } />
						<FieldWithStore fieldKey="user.email" store={ userStore } />
						{/* <FieldWithStore fieldKey="artist.paymentServiceID" store={ artistStore } /> */}
						<FieldWithStore fieldKey="user.dob" store={ userStore } />
					</div>

					<div className="small-12 large-4 cell">
						<FieldWithStore fieldKey="user.firstName" store={ userStore } />
						<FieldWithStore fieldKey="user.lastName" store={ userStore } />
						<FieldWithStore fieldKey="artist.phoneNumber" store={ artistStore } />
						<FieldWithStore fieldKey="user.location" store={ userStore } />
						{/* <FieldWithStore fieldKey="artist.genre" store={ artistStore } optionsStore={ genreStore } /> */}
					</div>

					<div className="small-12 large-4 cell">
						{/* <FieldWithStore fieldKey="artist.hfmPicksOptIn" store={ artistStore } /> */}
						<FieldWithStore fieldKey="user.status" store={ userStore } />

						<h4 className="padding-top-2">Set Default Password</h4>
						<ConfirmButton
							warningText={ 'Really reset to the default password? The new password will be "PleaseChangeM3!"' }
							onConfirmClick={ this.onResetPasswordConfirmClick }>
								<button className="button secondary hollow expanded">
									Set Default Password
								</button>
								<div>
									<em>The new password will be "PleaseChangeM3!"</em>
								</div>
						</ConfirmButton>
					</div>
				</div>

				<div className="grid-x grid-padding-y">
					<div className="cell auto">
						<div className="grid-x">
							<div className="cell shrink padding-right-1">
								<button
									data-ta="artistInfoSaveChanges"
									className="button hollow large"
									onClick={ this.onClick }>
										<span className="fas fa-save"></span> Save Changes
								</button>
							</div>

							<div className="cell shrink">
								<ConfirmButton
									warningText={ `Really delete ${userStore.get('user.userName')}?` }
									onConfirmClick={ this.onConfirmClick }>
										<button className="button hollow alert large">
											<span className="fas fa-trash"></span> Delete Fan
										</button>
								</ConfirmButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	async onClick () {
		const { artistStore, userStore } = this.props;

		await artistStore.saveArtist();
		await userStore.saveUser();
		toast.success('Saved!');
	}

	@autobind
	async onConfirmClick () {
		const { artistStore } = this.props;
		try {

			await artistStore.deleteItem(artistStore.data.artist.toPOJO());
			window.location.hash = '#/manage-fans/ACTIVE/TIER_1';
		} catch (err) {

			console.error('[ERROR DELETING FAN]', err);
		}
	}

	@autobind
	async onResetPasswordConfirmClick () {
		const { apiStore, userStore } = this.props;
		const data = await apiStore.setDefaultPassword(userStore.get('_id'));
		toast.success('Password reset to default!');
	}
}

export default EditArtistForm;
